import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";

// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import FormCatalogoBiblio from "../element/FormCatalogoBiblio";
import FotoBiblio from "../element/FotoBiblio";
import CardCatalogoBiblio from "../element/CardCatalogoBiblio";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
import Footer from './Footer';

const BiblioCatalogo = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
  //State del formulario
  const [catalogo, setCatalogo] = useState({
    tipo: 1,
    txtbuscar: "",
  });
  const [resultado, setResultados] = useState({});
  const [consultar, setConsultar] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [cargando, setCargando] = useState(false);
  let [alert, setalert] = useState('text-warning catalogoResult');

  const { tipo, txtbuscar } = catalogo;
  const numRow = 5;

  useEffect(() => {

    // loadMenu();

    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      if (consultar) {
        const conultarAPI = async () => {
          setCargando(true);
          await GetFetch.catalogo(
            tipo,
            txtbuscar,
            dataUser.token,
            dataUser.carnet,
            pagina,
            numRow
          ).then((dataCatalogo) => {
            let totalEncontrados = dataCatalogo.pop().totalRegistros;
            // setTotalRow(totalEncontrados);
            setResultados(dataCatalogo);
            setTotalPaginas(Math.ceil(+totalEncontrados / numRow));
            setCargando(false);
          }).catch(() => setCargando(false));
        };
        const carbody = document.querySelector('.card-body');
        carbody.scrollIntoView({ behavior: 'smooth' });
        conultarAPI();
        setConsultar(false);
        if(resultado.length === undefined){
          setalert('text-warning');
        }
      }

    } else {
      history.push("/");
    }

    loadMenu();
  }, [datos, history, dataUser, consultar, tipo, txtbuscar, pagina, resultado]);

  const paginaAnterior = () => {
    const paginaActual = pagina - 1;
    if (paginaActual === 0) return;
    setPagina(paginaActual);
    setConsultar(true);
    loadMenu();
  };

  const paginaSiguiente = () => {
    const paginaActual = pagina + 1;
    if (paginaActual > totalPaginas) return;
    setPagina(paginaActual);
    setConsultar(true);
    loadMenu();
  };


  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Catálogo CCESEN</h2>

        <div className="card mb-4">
          <div className="card-body">
            <FormCatalogoBiblio
              catalogo={catalogo}
              setCatalogo={setCatalogo}
              setConsultar={setConsultar}
              setPagina={setPagina}
            />
          </div>
        </div>

        {cargando ? (
          <SkeletonCard rows={5} />
        ) : resultado.length > 0 ? (
          <>
            {resultado.map((elem, i) => (
              <div className="card mb-3" key={`${pagina}-${i}`}>
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-3">
                      <FotoBiblio
                        foto={elem.portada}
                        alt="Libro de biblioteca CCESEN"
                        tamanio="rounded mx-auto d-block"
                      />
                    </div>
                    <div className="col-12 col-sm-9">
                      <CardCatalogoBiblio
                        titulo={elem.titulos}
                        resumen={elem.datos}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="d-flex align-items-center justify-content-between mt-3">
              <div>
                {pagina === 1 ? null : (
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm mr-2"
                    onClick={paginaAnterior}
                  >
                    <i className="fa fa-angle-left mr-1" aria-hidden="true"></i>
                    Anterior
                  </button>
                )}

                {pagina === totalPaginas ? null : (
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={paginaSiguiente}
                  >
                    Siguiente
                    <i className="fa fa-angle-right ml-1" aria-hidden="true"></i>
                  </button>
                )}
              </div>
              <small className="text-muted">
                Página {pagina} de {totalPaginas}
              </small>
            </div>
          </>
        ) : (
          <div className={alert}>
            <EmptyState icon="fa-search" title="No se encontraron resultados">
              Prueba con otros términos o cambia el criterio de búsqueda.
            </EmptyState>
          </div>
        )}
      </div>
    </div>
  );
};

export default BiblioCatalogo;
